import { priceCustomFilter } from './custom';
import { priceSimpleFilter } from './simple';
import {
  getClusterMinMaxPrice,
  getCustomClusterMinMaxPrice,
} from './available';

export const priceFilter = (searchResults, priceSelected, isCustom) =>
  isCustom
    ? priceCustomFilter(searchResults, priceSelected)
    : priceSimpleFilter(searchResults, priceSelected);

export const getPriceBySearchType = isCustom =>
  isCustom ? getCustomClusterMinMaxPrice : getClusterMinMaxPrice;
